import { DynamicFormV2Palette } from "@mui/material";

export type FormButtonComponentTokenType = {
  solid: {
    backgroundColor: string;
    hoverBackgroundColor: string;
    color: string;
  };
  tonal: {
    backgroundColor: string;
    hoverBackgroundColor: string;
    color: string;
  };
  outline: {
    backgroundColor: string;
    hoverBackgroundColor: string;
    borderColor: string;
    color: string;
  };
  ghost: {
    backgroundColor: string;
    hoverBackgroundColor: string;
    color: string;
  };
};

export const assignButtonComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    solid: {
      backgroundColor: isLightMode ? formsPalette.surface.intense : formsPalette.surface.reverse,
      hoverBackgroundColor: formsPalette.surface.hover.intense,
      color: formsPalette.text.reverse,
    },
    tonal: {
      backgroundColor: isLightMode ? formsPalette.surface.moderate : formsPalette.surface.reverse,
      hoverBackgroundColor: isLightMode ? formsPalette.surface.hover.moderate : formsPalette.surface.hover.intense,
      color: isLightMode ? formsPalette.text.intense : formsPalette.text.reverse,
    },
    outline: {
      backgroundColor: formsPalette.surface.supershy,
      hoverBackgroundColor: formsPalette.surface.hover.quiet,
      borderColor: formsPalette.border.moderate,
      color: formsPalette.text.intense,
    },
    ghost: {
      backgroundColor: "transparent",
      hoverBackgroundColor: formsPalette.surface.hover.quiet,
      color: formsPalette.text.intense,
    },
  } as FormButtonComponentTokenType;
};
